import AIResponseActionMatrix from './AIResponseActionMatrix';

export * from './AIResponseActionMatrix.types';
export default AIResponseActionMatrix;
